import { lazyWithPreload, withResolvedPreload } from "@/utils/lazyWithPreload";
import ContactPageComponent from "../pages/ContactPage";
import MortgagePageComponent from "../pages/MortgagePage";
import PrivateLoanPageComponent from "../pages/PrivateLoanPage";
import BusinessLoanPageComponent from "../pages/BusinessLoanPage";
import KlarsprakPageComponent from "../pages/KlarsprakPage";
import LoanWithoutUCPageComponent from "../pages/LoanWithoutUCPage";

/**
 * Preloadable route components for navigation preloading
 * Separated from App.tsx to avoid circular dependencies
 */

// Primary navigation pages stay in the main app bundle. They are clicked often,
// so they should not depend on a late route chunk that can flash blank or fail
// during deploy rollovers.
export const ContactPage = withResolvedPreload(ContactPageComponent);
export const MortgagePage = withResolvedPreload(MortgagePageComponent);
export const PrivateLoanPage = withResolvedPreload(PrivateLoanPageComponent);
export const BusinessLoanPage = withResolvedPreload(BusinessLoanPageComponent);
export const KlarsprakPage = withResolvedPreload(KlarsprakPageComponent);
export const LoanWithoutUCPage = withResolvedPreload(LoanWithoutUCPageComponent);

// Tool pages
export const MortgageCalculatorPage = lazyWithPreload(() => import("../pages/MortgageCalculatorPage"));
export const PrivateLoanCalculatorPage = lazyWithPreload(() => import("../pages/PrivateLoanCalculatorPage"));
export const InterestRateCalculatorPage = lazyWithPreload(() => import("../pages/InterestRateCalculatorPage"));
export const KALPCalculatorPage = lazyWithPreload(() => import("../pages/KALPCalculatorPage"));
